// src/components/profile/ProfileCompletionCheck.js
import React from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import ProfileCompletionNotification from "./ProfileCompletionNotification";
import ProfileVerificationRequiredNotification from "./ProfileVerificationRequiredNotification";
import { useAuth } from "../../context/AuthContext";

const ProfileCompletionCheck = ({ children }) => {
    const { user } = useAuth();
    const location = useLocation();

    // Admins don't need profile completion
    const isAdmin = user?.role === "admin" || user?.groups?.includes("admin");

    // Bypass check if on edit page or if user is admin
    if (location.pathname === '/profile/edit' || isAdmin) {
        return children;
    }

    // Trust user.profileComplete from AuthContext (API-verified on login)
    if (!user?.profileComplete) {
        return (
            <>
                {/* Background page content — blurred and non-interactive */}
                <div className="blur-sm pointer-events-none select-none brightness-75">
                    {children}
                </div>
                {/* Modal overlay — fixed, blocks interaction */}
                <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
                    <AnimatePresence>
                        <ProfileCompletionNotification />
                    </AnimatePresence>
                </div>
            </>
        );
    }

    // Check if owner profile is verified by admin (only for owner routes)
    const isOwnerRoute = location.pathname.startsWith('/owner/') || 
                        location.pathname === '/dashboard/create-room' || 
                        location.pathname === '/dashboard/create-mess';
    
    if (user?.role === 'owner' && isOwnerRoute && !user?.profileVerified) {
        return (
            <>
                {/* Background page content — blurred and non-interactive */}
                <div className="blur-sm pointer-events-none select-none brightness-75">
                    {children}
                </div>
                {/* Modal overlay — fixed, blocks interaction */}
                <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
                    <AnimatePresence>
                        <ProfileVerificationRequiredNotification
                            verificationStatus={user?.verificationStatus}
                            verificationNotes={user?.verificationNotes}
                        />
                    </AnimatePresence>
                </div>
            </>
        );
    }

    return children;
};

export default ProfileCompletionCheck;
